import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { api } from '../common/config';

export const apiSlice = createApi({
  reducerPath: '/',
  baseQuery: fetchBaseQuery({ baseUrl: api }),
  endpoints: () => ({}),
  tagTypes: [
    'updateSection',
    'updateFactSheet',
    'updateField',
    'updateTable',
    'getSections',
    'getCertification',
    'districtComments',
    'districtAttachments',
  ],
});

export type RootState = ReturnType<typeof apiSlice.reducer>;
